import { render, staticRenderFns } from "./chooseimg.vue?vue&type=template&id=5210cff0&scoped=true"
import script from "./chooseimg.vue?vue&type=script&lang=js"
export * from "./chooseimg.vue?vue&type=script&lang=js"
import style0 from "./chooseimg.vue?vue&type=style&index=0&id=5210cff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210cff0",
  null
  
)

export default component.exports